import axios from "axios";

// Dynamically set baseURL based on hostname
const getBaseURL = () => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8000/api/';
  } else {
    return 'https://timeberlo.com:8089/api/';
  }
};

axios.defaults.baseURL = getBaseURL();
axios.defaults.withCredentials = true;

// Restore token from localStorage on page load
// On admin panel pages, prefer adminToken over authToken
const isAdminPage = window.location.pathname.startsWith('/adminpanel');
const savedToken = isAdminPage
  ? (localStorage.getItem('adminToken') || localStorage.getItem('authToken'))
  : localStorage.getItem('authToken');
if (savedToken) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${savedToken}`;
}

let refresh = false;

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 && !refresh) {
      refresh = true;
      try {
        const isAdminPage = window.location.pathname.startsWith('/adminpanel');
        const isAdminRequest = error.config.url.startsWith('admin/') || isAdminPage;
        const response = await axios.post(
          isAdminRequest ? 'admin/refresh' : 'refresh',
          {},
          { withCredentials: true }
        );

        if (response.status === 200) {
          const token = response.data.token;
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          if (isAdminRequest) {
            localStorage.setItem('adminToken', token);
          } else {
            localStorage.setItem('authToken', token);
          }
          return axios(error.config);
        }
      } catch (refreshError) {
        if (window.location.pathname.startsWith('/adminpanel')) {
          localStorage.removeItem('adminToken');
        } else {
          localStorage.removeItem('authToken');
        }
        delete axios.defaults.headers.common['Authorization'];
      }
    }
    refresh = false;
    return Promise.reject(error);
  }
);